export default __webpack_public_path__ + "static/media/1_spwn.bea72212.jpg";